import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { FileText, Loader2 } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { DocumentDialog } from "./DocumentDialog";

export function DocumentsTab({ meta }) {
  const [docs, setDocs] = useState(null);
  const [openId, setOpenId] = useState(null);
  const load = () => api.get("/governance/documents").then((r) => setDocs(r.data));
  useEffect(() => { load(); }, []);
  if (!docs) return <Loader2 className="mx-auto mt-10 h-6 w-6 animate-spin text-accent" />;

  return (
    <div className="space-y-4" data-testid="documents-tab">
      <div>
        <h2 className="font-heading text-lg font-bold text-slate-900">Document Library</h2>
        <p className="text-sm text-slate-500">Versioned, product-specific drafts. PDFs carry a DRAFT watermark until approved.</p>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {docs.map((d) => (
          <Card key={d.id} onClick={() => setOpenId(d.id)} className="cursor-pointer border-slate-200 p-4 shadow-sm transition-colors hover:border-accent" data-testid={`document-row-${d.key}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex gap-3">
                <FileText className="mt-0.5 h-5 w-5 shrink-0 text-accent" />
                <div>
                  <div className="font-heading font-bold text-slate-900">{d.title}</div>
                  <div className="text-xs text-slate-500">{d.category} · v{d.current_version} · {d.audience}</div>
                </div>
              </div>
              <StatusBadge status={d.status} />
            </div>
          </Card>
        ))}
      </div>
      <DocumentDialog docId={openId} statuses={meta.doc_statuses} onClose={() => setOpenId(null)} onChanged={load} />
    </div>
  );
}
